import React from 'react';
import { Provider as AppBridgeProvider, useAppBridge } from '@shopify/app-bridge-react';
import { Page, Layout, Banner } from '@shopify/polaris';
import { getSessionToken } from '@shopify/app-bridge/utilities';
import { CreateBundleForm } from './components/CreateBundleForm';

function AppContent() {
  const app = useAppBridge();

  return (
    <Page title="Product Bundle Discounts">
      <Layout>
        <Layout.Section>
          <CreateBundleForm />
        </Layout.Section>
      </Layout>
    </Page>
  );
}

export default function App() {
  const urlParams = new URLSearchParams(window.location.search);
  const shop = urlParams.get('shop');
  const host = urlParams.get('host');

  if (!shop || !host) {
    return (
      <Page>
        <Layout>
          <Layout.Section>
            <Banner status="critical">
              <p>Missing required parameters. Please access this app through your Shopify admin panel.</p>
            </Banner>
          </Layout.Section>
        </Layout>
      </Page>
    );
  }

  const config = {
    apiKey: 'c66f35c6dda0a79b223ccd6bdfc36765',
    host: host,
    forceRedirect: true
  };

  return (
    <AppBridgeProvider config={config}>
      <AppContent />
    </AppBridgeProvider>
  );
} 